module.exports = __webpack_public_path__ + "img/mobile_type_two.2b76c0a2.png";